/* eslint-disable no-new */
import React, { Component } from "react"
import { graphql, StaticQuery } from "gatsby"
import classNames from "classnames"
import MenuItem from "./MenuItem"
import Link from "@components/Link"
import * as styles from "../../styles/layout/header.module.scss"
import * as buttonStyles from "~/styles/components/button.module.scss"
import * as navStyles from "../../styles/layout/nav.module.scss"

const AIRCRAFT_APPROVAL_SLUG = "approved-aircraft"
const AIRCRAFT_APPROVAL_FULL_SLUG = "services/approved-aircraft"
const AIRCRAFT_APPROVAL_SUBNAV = [
  {
    id: "aircraft-approval-1",
    title: "Application Process",
    page: {
      slug: "application-process",
      full_slug: "/services/approved-aircraft/application-process",
    },
  },
  {
    id: "aircraft-approval-2",
    title: "Application Form",
    page: {
      slug: "https://londoncityairport.formstack.com/forms/pjc_aircraft_approval",
      full_slug:
        "https://londoncityairport.formstack.com/forms/pjc_aircraft_approval",
    },
  },
  {
    id: "aircraft-approval-3",
    title: "Approved Operators and Aircraft",
    page: {
      slug: "approved-operators-and-aircraft",
      full_slug: "/services/approved-operators-and-aircraft",
    },
  }
]

export default class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeItem: null,
      open: false,
    }
  }

  toggleMenu(e) {
    this.setState(() => {
      return { open: !this.state.open }
    })

    const toggleClass = this.state.open ? "add" : "remove"
    document.body.classList[toggleClass]("nav-open")
  }

  // Menu item hover/focus handlers to control active state for dropdowns

  onItemMouseEnter(id) {
    this.setState({ activeItem: id })
  }

  onItemMouseLeave() {
    this.setState({ activeItem: null })
  }

  onItemFocus(id) {
    this.setState({ activeItem: id })
  }

  onItemFocusBlur() {
    this.setState({ activeItem: null })
  }

  render() {
    const _render = ({ contentfulMenu }) => {
      const items = contentfulMenu.items
        ?.filter((item) => item.contentfulparent === null)
        ?.map((item) => {
          // Add custom subnav for Approved Aircraft page
          if (item.page.slug === AIRCRAFT_APPROVAL_SLUG) {
            item.page.full_slug = AIRCRAFT_APPROVAL_FULL_SLUG
            item.children = AIRCRAFT_APPROVAL_SUBNAV
          } else {
            item.children = contentfulMenu.items.filter(
              (child) =>
                child.contentfulparent && child.contentfulparent.id === item.id
            )
          }

          return item
        })

      return (
        <header className={styles.header} ref={this.headerRef}>
          <div className={classNames("grid-container", styles.inner)}>
            <div className={classNames(styles.links)}>
              <button
                type="button"
                className={styles.toggle}
                onClick={this.toggleMenu.bind(this)}
                onFocus={this.toggleMenu.bind(this)}
                aria-label="Toggle menu"
              >
                <span className={styles.lines}></span>
              </button>

              <Link
                href="/"
                className={classNames(styles.icon, "logo-small")}
                aria-label="Go to homepage"
              >
                <img
                  src={"/logo-heart.png"}
                  aria-hidden="true"
                  alt="Heart Logo"
                />
              </Link>

              <Link
                href="/"
                className={classNames(styles.icon, styles.navlogo)}
                onClick={() => this.toggleMenu()}
                aria-label="Go to homepage"
              >
                <img
                  src={"/logo-full-stacked.png"}
                  aria-hidden="true"
                  alt="Private Jet Center Logo"
                />
              </Link>
            </div>

            <Link
              href="/"
              className={classNames(
                styles.logoFull,
                "logo-full show-for-large"
              )}
              aria-label="Go to homepage"
            >
              <img
                src={"/logo-full-stacked.png"}
                aria-hidden="true"
                alt="Private Jet Center Logo"
              />
            </Link>

            <nav className={classNames(navStyles.nav)}>
              <ul className={navStyles.menu}>
                {items.map((item) => (
                  <MenuItem
                    key={item.id}
                    item={item}
                    active={this.state.activeItem === item.id}
                    onMouseEnter={this.onItemMouseEnter.bind(this, item.id)}
                    onMouseLeave={this.onItemMouseLeave.bind(this)}
                    onFocus={this.onItemFocus.bind(this, item.id)}
                    onBlur={this.onItemFocusBlur.bind(this)}
                    onClick={() => this.toggleMenu()}
                  />
                ))}
                <li
                  className={classNames(navStyles.menuItem, "hide-for-large")}
                >
                  <Link
                    href="/get-in-touch"
                    className=""
                    aria-label="Get In Touch"
                    track={{
                      category: "intent-pjc-ContactForm",
                      action: "Click",
                      label: "Get In Touch",
                    }}
                    fbTrack={{
                      name: "IntentContact",
                    }}
                  >
                    Get In Touch
                  </Link>
                </li>
              </ul>
            </nav>

            <Link
              href="/get-in-touch"
              className={classNames(styles.button, buttonStyles.button)}
              aria-label="Get In Touch"
              track={{
                category: "intent-pjc-Contact",
                action: "Click",
                label: "Get In Touch",
              }}
              fbTrack={{
                name: "IntentContact",
              }}
            >
              Get In Touch
            </Link>
          </div>
        </header>
      )
    }

    return <StaticQuery query={query} render={_render} />
  }
}

export const query = graphql`
  query {
    contentfulMenu(name: { eq: "main-menu" }) {
      items {
        id
        title
        page {
          slug
        }
        contentfulparent {
          id
        }
      }
    }
  }
`
